import { render, staticRenderFns } from "./captchaPanel.vue?vue&type=template&id=18d37356&scoped=true&"
import script from "./captchaPanel.vue?vue&type=script&lang=js&"
export * from "./captchaPanel.vue?vue&type=script&lang=js&"
import style0 from "./captchaPanel.vue?vue&type=style&index=0&id=18d37356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d37356",
  null
  
)

export default component.exports